import { html, TemplateResult, CSSResultGroup } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { OutlineElement } from '../../base/outline-element/outline-element';
import componentStyles from './idb-image-banner-search.css.lit';
import { classMap } from 'lit/directives/class-map.js';

/**
 * The CTA Banner component.
 * @element idb-image-banner-search
 * @property center heading - centers the heading and makes it smaller
 * @slot background - Background image
 * @slot heading - Heading
 * @slot search form
 */

@customElement('idb-image-banner-search')
export class ImageBannerSearch extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  @property({ type: String, reflect: true, attribute: 'image-url' })
  imageURL: string;

  @property({ type: String, reflect: true, attribute: 'image-alt' })
  imageAlt: string;

  @property({ type: String, reflect: true, attribute: 'bg-color' })
  bgColor: string;

  render(): TemplateResult {
    const cardClasses = {
      wrapper: true,
      [`bg-color--${this.bgColor}`]: this.bgColor,
    };

    const textClasses = {
      'text-wrapper': true,
      'centered': true,
    };

    const headingClasses = {
      heading: true,
    };

    const formClasses = {
      'banner-search-forms': true,
    };

    const bgImage = this.imageURL
      ? `style="background-image: url(${this.imageURL})`
      : '';

    return html`
      <div class="${classMap(cardClasses)}" ${bgImage}>
        <div class="${classMap(textClasses)}">
          <div class="${classMap(headingClasses)}">
            <slot name="heading"></slot>
          </div>
          <div class="${classMap(formClasses)}">
            <slot name="forms"></slot>
          </div>
        </div>
      </div>
    `;
  }
}
